/** Short display labels for OASIS visit type IDs. */
export const OASIS_VISIT_TYPE_LABELS: Record<string, string> = {
  OASIS_E2_START_OF_CARE: 'SOC',
  OASIS_E2_RESUMPTION_OF_CARE: 'ROC',
  OASIS_E2_RECERTIFICATION: 'REC',
  OASIS_E2_RECERTIFICATION_ENHANCED: 'REC',
  OASIS_E2_DISCHARGE: 'DC',
  OASIS_E2_DISCHARGE_ENHANCED: 'DC',
  OASIS_E2_START_OF_CARE_PT: 'SOC (PT)',
  OASIS_E2_RESUMPTION_OF_CARE_PT: 'ROC (PT)',
  OASIS_E2_RECERTIFICATION_PT: 'REC (PT)',
  OASIS_E2_RECERTIFICATION_PT_ENHANCED: 'REC (PT)',
  OASIS_E2_DISCHARGE_PT: 'DC (PT)',
  OASIS_E2_DISCHARGE_PT_ENHANCED: 'DC (PT)',
  OASIS_E2_START_OF_CARE_OT: 'SOC (OT)',
  OASIS_E2_RESUMPTION_OF_CARE_OT: 'ROC (OT)',
  OASIS_E2_RECERTIFICATION_OT: 'REC (OT)',
  OASIS_E2_RECERTIFICATION_OT_ENHANCED: 'REC (OT)',
  OASIS_E2_DISCHARGE_OT: 'DC (OT)',
  OASIS_E2_DISCHARGE_OT_ENHANCED: 'DC (OT)',
  OASIS_E2_START_OF_CARE_ST: 'SOC (ST)',
  OASIS_E2_RESUMPTION_OF_CARE_ST: 'ROC (ST)',
  OASIS_E2_RECERTIFICATION_ST: 'REC (ST)',
  OASIS_E2_RECERTIFICATION_ST_ENHANCED: 'REC (ST)',
  OASIS_E2_DISCHARGE_ST: 'DC (ST)',
  OASIS_E2_DISCHARGE_ST_ENHANCED: 'DC (ST)',
  OASIS_E2_FOLLOW_UP: 'FUP',
  OASIS_E2_FOLLOW_UP_ENHANCED: 'FUP',
  OASIS_E2_TRANSFER: 'TF',
  OASIS_E2_TRANSFER_ENHANCED: 'TF',
  OASIS_E2_DEATH: 'DD',
  OASIS_E2_DEATH_ENHANCED: 'DD',
  OASIS_E2_FOLLOW_UP_PT: 'FUP (PT)',
  OASIS_E2_FOLLOW_UP_PT_ENHANCED: 'FUP (PT)',
  OASIS_E2_TRANSFER_PT: 'TF (PT)',
  OASIS_E2_TRANSFER_PT_ENHANCED: 'TF (PT)',
  OASIS_E2_DEATH_PT: 'DD (PT)',
  OASIS_E2_DEATH_PT_ENHANCED: 'DD (PT)',
  OASIS_E2_FOLLOW_UP_OT: 'FUP (OT)',
  OASIS_E2_FOLLOW_UP_OT_ENHANCED: 'FUP (OT)',
  OASIS_E2_TRANSFER_OT: 'TF (OT)',
  OASIS_E2_TRANSFER_OT_ENHANCED: 'TF (OT)',
  OASIS_E2_DEATH_OT: 'DD (OT)',
  OASIS_E2_DEATH_OT_ENHANCED: 'DD (OT)',
  OASIS_E2_FOLLOW_UP_ST: 'FUP (ST)',
  OASIS_E2_FOLLOW_UP_ST_ENHANCED: 'FUP (ST)',
  OASIS_E2_TRANSFER_ST: 'TF (ST)',
  OASIS_E2_TRANSFER_ST_ENHANCED: 'TF (ST)',
  OASIS_E2_DEATH_ST: 'DD (ST)',
  OASIS_E2_DEATH_ST_ENHANCED: 'DD (ST)',
};
